import { QuickLeadForm } from "./quick-lead-form";

/**
 * Compact quote form placed directly under a page hero so visitors never have
 * to hunt for a CTA. On the home page the hero already embeds the form at `lg`,
 * so that instance passes `mobileOnly` to avoid duplication.
 */
export function TopQuoteForm({
  source = "Top Form",
  defaultService = "",
  mobileOnly = false,
  heading = "Get a Free Quote Fast",
}: {
  source?: string;
  defaultService?: string;
  mobileOnly?: boolean;
  heading?: string;
}) {
  return (
    <section
      id="top-quote"
      aria-label="Quick free quote"
      className={
        "bg-white py-10 md:py-12 scroll-mt-24 " + (mobileOnly ? "lg:hidden" : "")
      }
    >
      <div
        className={
          mobileOnly
            ? "mx-auto max-w-[480px] px-4"
            : "mx-auto max-w-[900px] px-4 lg:grid lg:grid-cols-[1fr_420px] lg:gap-10 lg:items-center"
        }
      >
        {!mobileOnly && (
          <div className="hidden lg:block">
            <h2
              className="text-3xl uppercase text-[var(--brand-deep-blue)] tracking-tight"
              style={{ fontFamily: "var(--font-display)", fontWeight: 700 }}
            >
              {heading}
            </h2>
            <p className="mt-3 text-[var(--brand-charcoal)]/80 leading-relaxed">
              Tell us what you need cleaned and we'll text or call you back fast with a
              no-obligation estimate. Free quotes across the Capital Region.
            </p>
          </div>
        )}
        <QuickLeadForm source={source} defaultService={defaultService} />
      </div>
    </section>
  );
}
